import type { BranchKey, WorkspaceKey } from '@festina-life/api'
import { useCallback, useState } from 'react'

import type { WorkspaceCreateOrUpdateInput } from '../../uiModels/workspace/types'
import { useWorkspaceManagerContext } from '../../workspace/workspaceManagerContext'

export const useCreateWorkspace = (branchKey: BranchKey) => {
  const [error, setError] = useState<Error>()
  const { onCreate } = useWorkspaceManagerContext()
  const [isCreating, setIsCreating] = useState(false)

  const handleSubmit = useCallback(
    async ({ name }: WorkspaceCreateOrUpdateInput) => {
      setError(undefined)

      const createInput = {
        name,
        branchKey,
      } satisfies WorkspaceCreateOrUpdateInput

      try {
        setIsCreating(true)
        await onCreate(createInput, true)

        return {
          name: createInput.name,
          branchKey,
        } satisfies WorkspaceKey
      } catch (error) {
        setError(error)
        throw error
      } finally {
        setIsCreating(false)
      }
    },
    [branchKey, onCreate],
  )

  return { mutateAsync: handleSubmit, isPending: isCreating, error }
}
